var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',[_vm._v(" Internal Reports ")])])],1),_c('v-row',[_vm._l((_vm.reports),function(item,i){return [_c('report-card',{key:i,attrs:{"item":item}})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }